import React, { ReactNode } from 'react';

import {
  Modal as CModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button as CButton,
  useDisclosure,
  Flex,
  Button as ButtonChakra,
} from '@chakra-ui/react';

import { Button, CustomIcon } from 'components';

interface IProps {
  title: string | ReactNode;
  header: string;
  body: string | ReactNode;
  onClick(): void;
  yesText: string;
  noText: string;
  disabled?: boolean;
  typeStatus?: boolean;
  variant?: 'primary' | 'danger';
}

const ModalComp = (props: IProps): JSX.Element => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    header,
    body,
    onClick,
    disabled,
    yesText,
    noText,
    title,
    variant,
    typeStatus = false,
  } = props;
  const handleClick = React.useCallback(() => {
    onClick();
    onClose();
  }, [onClick]);
  return (
    <>
      {typeStatus ? (
        <ButtonChakra
          onClick={onOpen}
          colorScheme="red"
          borderRadius="4rem"
          height="1.85rem"
          fontSize="13px"
          p="0.1rem 2rem"
        >
          {title}
        </ButtonChakra>
      ) : (
        <Button onClick={onOpen} type="button" variant={variant} outline disabled={disabled}>
          {title}
        </Button>
      )}

      <CModal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <Flex justifyContent="space-between">
            <ModalHeader fontSize="18px" flex={1} color="brand.black700">
              {header}
            </ModalHeader>

            <CButton onClick={onClose} backgroundColor="brand.white">
              <CustomIcon $noSphere icon="close" color="brand.red200" size="22px" $Cpos={''} />
            </CButton>
          </Flex>
          <Flex direction="column" alignItems="center">
            <ModalBody fontSize="14px">{body}</ModalBody>

            <ModalFooter>
              <CButton
                fontSize="14px"
                color="brand.black700"
                border="2.4px solid black"
                mr={3}
                onClick={onClose}
              >
                {noText}
              </CButton>
              <CButton
                fontSize="14px"
                color="brand.white200"
                backgroundColor="brand.red200"
                _hover={{
                  color: 'brand.black700',
                }}
                onClick={handleClick}
                type="button"
              >
                {yesText}
              </CButton>
            </ModalFooter>
          </Flex>
        </ModalContent>
      </CModal>
    </>
  );
};

export const Modal = React.memo(ModalComp);
